module.exports = __webpack_public_path__ + "img/left4.18387849.jpg";